import React from 'react';
import { Link } from 'react-router-dom';
import GalaxyCanvas from '../components/GalaxyCanvas';
import ProjectPreview from '../components/ProjectPreview';
import ContactNote from '../components/ContactNote';
import { projects } from '../data/projects';

export default function Home() {
    return (
        <>
            <section className="hero" aria-labelledby="intro-title">
                <GalaxyCanvas className="hero__canvas" />
                <div className="hero__scrim" />
                <div className="shell hero__layout">
                    <div className="hero__intro">
                        <p className="intro-role">Full-stack &amp; AI engineer</p>
                        <h1 id="intro-title">I'm Casey.<br />I build useful<br />software.</h1>
                        <p className="hero__description">From an AI assistant on your desktop to a measurement guide on your phone. I design the interface, build what runs behind it, and keep it working.</p>
                        <div className="hero__actions">
                            <a href="#work" className="button button--primary">Explore my work <span aria-hidden="true">↓</span></a>
                            <Link to="/about" className="text-link">A little about me</Link>
                        </div>
                    </div>
                    <div className="hero__foot">
                        <p><span className="availability-dot" />Open to projects &amp; collaborations</p>
                        <span>Based in California</span>
                    </div>
                </div>
            </section>
            <section id="work" className="work-section shell" aria-labelledby="work-title">
                <div className="section-heading">
                    <div><p className="section-kicker">Selected work</p><h2 id="work-title">A few things I've built.</h2></div>
                    <Link to="/projects" className="text-link">See the project details</Link>
                </div>
                <ProjectPreview project={projects[0]} featured />
                <div className="project-pair">{projects.slice(1).map(project => <ProjectPreview key={project.id} project={project} />)}</div>
            </section>
            <section className="working-section">
                <div className="shell working-layout">
                    <div><p className="section-kicker">Behind the work</p><h2>I like knowing how<br />the whole thing works.</h2><Link to="/about" className="text-link">More about my approach</Link></div>
                    <div className="working-copy">
                        <p>Most of my work sits between product design and engineering. I'll spend time on how a feature feels to use, then follow it down to the data, infrastructure, or model that makes it possible.</p>
                        <p>That means React and TypeScript for interfaces, Node.js and Python behind them, and a fair amount of time with local AI runtimes and Google Cloud.</p>
                        <div className="working-tools" aria-label="Core tools"><span>React / TypeScript</span><span>Node.js / Python</span><span>Firebase / Cloud Run</span><span>Electron / Local AI</span></div>
                    </div>
                </div>
            </section>
            <ContactNote />
        </>
    );
}
